<app-dashboard-option [categories]="['LAYOUT']" [label]="'COLOR'" [information]="dashboardLayout.color" [sublabel]="'OPACITY'" [subinformation]="opacity + '%'">
  <div app-dashboard-option-content>
    <app-color-picker [itemColor]="color" [color]="backgroundColor" (sendColor)="receiveValue($event)"></app-color-picker>
  </div>
  <div app-dashboard-option-subcontent>
    <app-slider [color]="color" [value]="opacity" (sendValue)="receiveOpacity($event)"></app-slider>
  </div>
</app-dashboard-option>